import { useCallback } from "react";
import { RootState } from "../store";
import * as AssinanteActions from "../store/Assinante.reducer";
import { useAppDispatch, useAppSelector } from "./hooks";

export default function useAssinante() {
  const dispatch = useAppDispatch();

  // Selects the single active subscriber from the assinante slice
  const assinante = useAppSelector(
    (state: RootState) => state.assinante.assinante,
  );

  const assinatura = useAppSelector(
    (state: RootState) => state.assinante.assinatura,
  );

  // Selects the list of subscribers from the assinante slice
  const assinantes = useAppSelector((state: RootState) => state.assinante.list);

  // Selects the fetching/loading status
  const fetching = useAppSelector(
    (state: RootState) => state.assinante.fetching,
  );

  // Triggers the thunk to fetch subscribers from the /subscribers endpoint
  const getAssinantes = useCallback(() => {
    dispatch(AssinanteActions.getAssinantes());
  }, [dispatch]);

  const getAssinatura = useCallback(() => {
    dispatch(AssinanteActions.getAssinatura());
  }, [dispatch]);

  return {
    assinante,
    assinatura,
    assinantes,
    getAssinantes,
    getAssinatura,
    fetching,
  };
}
